module.exports = __webpack_public_path__ + "c69bfc57aac369f25d934102bb97258b.svg";